export const getCanonicalUrl = (path?: string): string => {
    return `https://${process.env.NEXT_PUBLIC_HOSTNAME}${path}`;
};
